var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMariage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da0021;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.56,133.16a237.92,237.92,0,0,1-21.43,21.1C368.33,177.31,412,236.56,412,305.55c0,89.12-72.4,161.69-161.68,161.69A161.7,161.7,0,0,1,88.63,305.55c0-68.18,42.54-126.62,102.6-150.48A258.17,258.17,0,0,1,170,134.13,189.62,189.62,0,0,0,61.2,305.55C61.2,410.09,146.1,495,250.64,495s189.44-84.9,189.44-189.44C439.76,228.93,394,163,328.56,133.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.52,24.4C304.86,10.27,286.68,9.3,283.43,9.14c-12.33-.49-25,7.46-35.06,16.39C238.63,16.28,226.45,8.16,213.79,8c-2.76,0-21.26.32-34.57,14.12-17.37,17.7-13.15,44.16-12.5,48.54,7.63,51.46,74,87.82,79.38,92.53h0c8-4.06,78.73-40.42,82.62-95.29C329.37,58.32,330.67,39.17,317.52,24.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMariage);
export default __webpack_public_path__ + "static/media/mariage.a6093314.svg";
export { ForwardRef as ReactComponent };